module.exports = __webpack_public_path__ + "static/img/1.3593cd0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/1.png
// module id = f4b9
// module chunks = 0